import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { navigate } from '@reach/router'
import { deleteAuthInfo } from '../../state/auth'
import {useDispatch, useSelector} from 'react-redux'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import {UserService} from "../../services";
import {showSuccessToast} from "../../state/toasts";


export const UserDetails = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header className={'mr-3 text-center'} as="h3">
        {user.full_name}({user.role})
      </Popover.Header>
      <Popover.Body>
        <div className="header_user">
          <ReactBootstrap.NavDropdown.Item className="text-center">
            <div
              onClick={() => {
                navigate('/dashboard/profile')
              }}
            >
              <i className="fas fa-user-circle  fa-7x"></i>
            </div>
          </ReactBootstrap.NavDropdown.Item>
          <ReactBootstrap.NavDropdown.Divider />
          <ReactBootstrap.NavDropdown.Item
            className="text-left"
            onClick={() => {
              navigate('/dashboard')
            }}
          >
            My Dashboard
          </ReactBootstrap.NavDropdown.Item>
          <ReactBootstrap.NavDropdown.Divider />
          <ReactBootstrap.NavDropdown.Item
            className="text-left"
            onClick={() => {
              navigate('/dashboard/profile')
            }}
          >
            My Profile
          </ReactBootstrap.NavDropdown.Item>
          <ReactBootstrap.NavDropdown.Divider />
          <ReactBootstrap.NavDropdown.Item
            className="text-left"
            onClick={() => {
              navigate('/dashboard/password')
            }}
          >
            Change Password
          </ReactBootstrap.NavDropdown.Item>
          <ReactBootstrap.NavDropdown.Divider />
               {user && (user.role === 'SuperUser' || user.is_superuser) &&
                  <ReactBootstrap.NavDropdown.Item  onClick={()=>{
                new UserService().restartServer().then(()=>{
                   dispatch(showSuccessToast('Let The server two minutes to boot up.'))
                })

              }} size={"sm"}>Restart Server</ReactBootstrap.NavDropdown.Item>}     <ReactBootstrap.NavDropdown.Divider />

          <ReactBootstrap.NavDropdown.Item
            className="text-left"
            onClick={() => {
              dispatch(deleteAuthInfo())
            }}
          >
            Logout
          </ReactBootstrap.NavDropdown.Item>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <OverlayTrigger
      rootClose
      trigger="click"
      placement="bottom-start"
      overlay={popover}
    >
      <span className="pr-3 text-white">{user.full_name}</span>
    </OverlayTrigger>
  )
}
